<div class="notfound-outer">
  <div class="notfound-card">
    <div class="notfound-emoji">😕</div>
    <div class="notfound-title">404</div>
    <div class="notfound-subtitle">Page Not Found</div>
    <div class="notfound-message">
      The page you are looking for doesn’t exist or has been moved.
    </div>
    <a i18n routerLink="/orders"  href="#" class="notfound-home-btn">Go to Home</a>
  </div>
</div>

<style>
.notfound-outer {
  min-height: calc(100vh - 56px); /* Adjust 56px to your header height */
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  margin: 0;
  padding: 0;
}
.notfound-card {
  background: #fff;
  padding: 2.5rem 2rem 2rem 2rem;
  border-radius: 1.5rem;
  box-shadow: 0 8px 32px rgba(0,0,0,0.10);
  text-align: center;
  max-width: 400px;
  width: 100%;
}
.notfound-emoji {
  font-size: 3rem;
  margin-bottom: 0.5rem;
}
.notfound-title {
  font-size: 3.5rem;
  color: #e74c3c;
  font-weight: bold;
  margin-bottom: 0.2rem;
  letter-spacing: 2px;
}
.notfound-subtitle {
  font-size: 1.5rem;
  color: #123;
  margin-bottom: 1.2rem;
  font-weight: 600;
  letter-spacing: 1px;
}
.notfound-message {
  color: #555;
  margin-bottom: 2rem;
  font-size: 1.08rem;
}
.notfound-home-btn {
  display: inline-block;
  padding: 0.7rem 2.2rem;
  background: linear-gradient(90deg, #007bff 0%, #0056b3 100%);
  color: #fff;
  border-radius: 2rem;
  text-decoration: none;
  font-weight: 500;
  font-size: 1.1rem;
  box-shadow: 0 2px 8px rgba(0,123,255,0.10);
  transition: background 0.2s, box-shadow 0.2s;
  border: none;
}
.notfound-home-btn:hover {
  background: linear-gradient(90deg, #0056b3 0%, #007bff 100%);
  box-shadow: 0 4px 16px rgba(0,123,255,0.18);
}
</style>